var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconViewGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Solid/view-grid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00078 4.80078C6.23347 4.80078 4.80078 6.23347 4.80078 8.00078V11.2008C4.80078 12.9681 6.23347 14.4008 8.00078 14.4008H11.2008C12.9681 14.4008 14.4008 12.9681 14.4008 11.2008V8.00078C14.4008 6.23347 12.9681 4.80078 11.2008 4.80078H8.00078Z",
    fill: "#646A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00078 17.6008C6.23347 17.6008 4.80078 19.0335 4.80078 20.8008V24.0008C4.80078 25.7681 6.23347 27.2008 8.00078 27.2008H11.2008C12.9681 27.2008 14.4008 25.7681 14.4008 24.0008V20.8008C14.4008 19.0335 12.9681 17.6008 11.2008 17.6008H8.00078Z",
    fill: "#646A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6008 8.00078C17.6008 6.23347 19.0335 4.80078 20.8008 4.80078H24.0008C25.7681 4.80078 27.2008 6.23347 27.2008 8.00078V11.2008C27.2008 12.9681 25.7681 14.4008 24.0008 14.4008H20.8008C19.0335 14.4008 17.6008 12.9681 17.6008 11.2008V8.00078Z",
    fill: "#646A73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6008 20.8008C17.6008 19.0335 19.0335 17.6008 20.8008 17.6008H24.0008C25.7681 17.6008 27.2008 19.0335 27.2008 20.8008V24.0008C27.2008 25.7681 25.7681 27.2008 24.0008 27.2008H20.8008C19.0335 27.2008 17.6008 25.7681 17.6008 24.0008V20.8008Z",
    fill: "#646A73"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewGrid);
export default __webpack_public_path__ + "static/media/icon-view-grid.492c953132ebbe736d50076d85b0426a.svg";
export { ForwardRef as ReactComponent };